import { Box, Typography } from '@mui/material'
import React from 'react'

const TooltipPickUpAndDropOff = ({ columnDef = [] }) => {
    return (
        <Box sx={{
            backgroundColor: '#fff', display: 'inline-block', p: 1,
            boxShadow: '0 1px 4px rgba(0, 0, 0, 0.4)',
            border: '1px solid #00000026',
            borderRadius: '4px',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            width: '100%'

        }}>
            {columnDef.map((item) => (
                <Box>
                    <Typography variant="body1" style={{ display: "flex", alignItems: "start", marginBottom: "0px", color: '#444444', fontSize: '14px' }}>
                        <span
                            style={{ display: "inline-block", minWidth: "120px" }}
                        >{`${item.name}`}</span>{" "}
                        {" "}:{" "}
                        <span style={{ paddingLeft: '4px', flex: 1, }}>
                            {item?.value}
                        </span>
                    </Typography>
                </Box>
            ))}
        </Box>
    )
}

export default TooltipPickUpAndDropOff